import { Item } from "../data/ItemOfBusiness";
import { ApiStatus, callApi, ConflictError } from "./ApiUtilities";

export async function getItems(): Promise<Item[]> {
  const response = await callApi<Item[]>("/api/items", "GET");
  console.log(`Get Items response ${response.status}`);
  if (response.status === ApiStatus.Ok) {
    return response.data as Item[];
  } else if (response.status === ApiStatus.Unauthorised) {
    throw Error(`Not logged in, try refreshing page (${response.message}`);
  } else {
    throw Error("An Unknown API error occured. Response " + response.status + "- " + response.message);
  }
}

export async function saveItem(item: Item): Promise<Item> {
  const response = await callApi<Item>("/api/items", "POST", item);
  if (response.status === ApiStatus.Ok) {
    return response.data as Item;
  } else if (response.status === ApiStatus.Unauthorised) {
    throw Error(`Not logged in, try refreshing page (${response.message}`);
  } else if (response.status === ApiStatus.Conflict) {
    // changed by someone else, deleted (data null) or being voted on; data is the item as it is now
    throw new ConflictError<Item>(response.message, response.data);
  } else {
    throw Error("An Unknown API error occured. Response " + response.status + "- " + response.message);
  }
}

export async function deleteItem(item: Item): Promise<void> {
  const response = await callApi<Item>(`/api/items/${encodeURI(item.subId)}`, "DELETE", item);
  if (response.status === ApiStatus.Ok) {
    return;
  } else if (response.status === ApiStatus.Unauthorised) {
    throw Error(`Not logged in, try refreshing page (${response.message}`);
  } else {
    throw Error("An Unknown API error occured. Response " + response.status + "- " + response.message);
  }
}

/**
 * "Who's editing" presence for an item: call with true when an editor opens (and every
 * minute while open), false when it closes. Best effort; failures are ignored.
 */
export async function setItemEditing(subId: string, editing: boolean): Promise<void> {
  try {
    await callApi<unknown>(`/api/items/${encodeURIComponent(subId)}/editing`, "POST", { editing });
  } catch {
    // advisory only
  }
}
